import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  isLoggedIn: boolean = false;
  hasAdminAccess: boolean = false;
  
  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.loginEvent.subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        this.authService.getUser().then((user) => {
          this.hasAdminAccess = ['ADMIN'].some(role => user.userRoles.includes(role));
        });
      }
    });
  }
}